import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import { useLanguage } from "context/LanguageContext";
import SettingsSection from "./components/SettingsSection";
import SaveBar from "./components/SaveBar";
import useCompanyForm from "./useCompanyForm";

const FIELDS = { name: "", company_code: "", description: "" };

function CompanyDetailsTab({ companyId }) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { values, dirty, saving, setField, save } = useCompanyForm(companyId, FIELDS);

  if (!values) {
    return (
      <Box display="flex" justifyContent="center" py={6}>
        <CircularProgress />
      </Box>
    );
  }

  const nameMissing = !values.name.trim();

  return (
    <>
      <SettingsSection title={t("stCompanyDetails")} description={t("stCompanyDetailsHint")}>
        <TextField
          label={t("companyName")}
          value={values.name}
          onChange={setField("name")}
          error={nameMissing}
          helperText={nameMissing ? t("stCompanyNameRequired") : " "}
          fullWidth
        />
        <TextField
          label={t("companyCode")}
          value={values.company_code}
          onChange={setField("company_code")}
          helperText={t("stCompanyCodeHint")}
          fullWidth
        />
        <TextField
          label={t("description")}
          value={values.description}
          onChange={setField("description")}
          helperText={t("stDescriptionHint")}
          multiline
          minRows={2}
          fullWidth
        />
      </SettingsSection>
      <SaveBar
        dirty={dirty}
        saving={saving}
        onSave={save}
        disabled={nameMissing}
        extraActions={
          <MDButton
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/company-management")}
          >
            {t("stManageCompanies")}
          </MDButton>
        }
      />
    </>
  );
}

CompanyDetailsTab.propTypes = {
  companyId: PropTypes.number.isRequired,
};

export default CompanyDetailsTab;
